export default __webpack_public_path__ + "static/media/leaveReviewDisabled.b4bec416.svg";